import React from 'react'
import './index.less'
import { component_tool } from '@/tool'
let { WizModal, WizPopover } = component_tool

import WizTableForm from '@/containers/common/wizTableForm/wizTableForm'

const organizationConfig = WizTableForm.Config.organizationBrandNode(this, { apiParams: { state: 1, organizationNodeCategory: [2] } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const programConfig = WizTableForm.Config.offlineProgram(this, { apiParams: { state: 1 } })

//配置项
let componentName = 'personnelTraining'

const columns = [
  {
    name: 'id',
    dataIndex: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '品牌',
    name: 'orgId',
    dataIndex: 'orgId',
    searchItem: {
      ...organizationConfig,
      diy: WizTableForm,
      selectType: 'radio'
    },
    formItem: {
      ...organizationConfig,
      diy: WizTableForm,
      selectType: 'radio',
      formatDynamicProps: record => {
        let flag = record && record.id
        return {
          initialValue: flag ? record.orgId : undefined,
          initRows: flag ? [{ id: record.orgId, name: record.orgName }] : [],
          disabled: flag ? true : false
        }
      },
      rules: [{ required: true, message: '请选择品牌' }]
    }
  },
  {
    title: '品牌',
    name: 'orgName',
    dataIndex: 'orgName',
    tableItem: {}
  },
  {
    title: '辅导模块',
    name: 'moduleType',
    dataIndex: 'moduleType',
    dict: [
      { code: 0, codeName: '销售' },
      { code: 1, codeName: '售后' }
    ],
    searchItem: {
      type: 'select'
    },
    formItem: {
      type: 'select',
      formatDynamicProps: record => {
        return { disabled: record && record.id ? true : false }
      },
      rules: [{ required: true, message: '请选择辅导模块' }]
    },
    tableItem: {}
  },
  {
    title: '岗位',
    name: 'positionId',
    dataIndex: 'positionId',
    formItem: {
      ...positionConfig,
      diy: WizTableForm,
      selectType: 'radio',
      formatDynamicProps: record => {
        let flag = record && record.id
        return {
          initialValue: flag ? record.positionId : undefined,
          initRows: flag ? [{ id: record.positionId, name: record.positionName }] : [],
          disabled: flag ? true : false
        }
      },
      rules: [{ required: true, message: '请选择岗位' }]
    }
  },
  {
    title: '岗位',
    name: 'positionName',
    dataIndex: 'positionName',
    tableItem: {}
  },
  {
    title: '课程',
    name: 'programIds',
    dataIndex: 'programIds',
    formItem: {
      ...programConfig,
      diy: WizTableForm,
      selectType: 'checkbox',
      formatDynamicProps: record => {
        let flag = record && record.id        
        return {
          initialValue: flag ? record.programIds : [],
          initRows: flag ? record.programList || [] : []
        }
      },
      rules: [{ required: true, message: '请选择课程' }]
    }
  },
  {
    title: '课程',
    name: 'programList',
    dataIndex: 'programList',
    tableItem: {
      type: 'custom',
      render: (val = []) => {
        let result = []
        let content = ''
        if (val && val.length) {
          let { name, code } = val[0]
          result = [name + (code ? '(' + code + ')' : '')]
          content = val.map(item => <p>{item.name + (item.code ? '(' + item.code + ')' : '')}</p>)
          if (val.length > 1) {
            result.push(<span className='manager-person-training-programs'> ...</span>)
          }
        }
        return <WizPopover content={content} placement='rightTop' >{result}</WizPopover>
      }
    }
  },
  {
    title: '状态',
    name: 'state',
    dataIndex: 'state',
    dict: [
      { code: 0, codeName: '禁用' },
      { code: 1, codeName: '启用' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {
      type: 'select'
    }
  }
]

const templateConfig = {
  mainProps: {},
  content: {
    name: 'WizTableList',
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['add', 'export'],
        buttons: [
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export' },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'export',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters }
              }
            }
          }
        ],
        collapse: false
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: 'id',
        isScroll: true,
        loading: false
      },
      rowOperateSort: ['update', 'enableOrDisable'],
      rowOperateView: [
        {
          key: 'enableOrDisable',
          custom: true,
          params: { children: '启用' },
          textFormat: {
            recordKey: 'state',
            dirt: { 0: '启用', 1: '禁用' }
          },
          customOnClick: {
            key: 'action',
            params: {
              apiKey: 'enable',
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${record['state'] === 0 ? '启用' : '禁用'}该配置吗？`
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: record['state'] === 1 ? 0 : 1,
                    id: record['id']
                  })
                },
                onCancel() {
                }
              })
              return null
            }
          }
        }
      ]
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
